import React from 'react';
import { nodeTheme } from './nodeTheme';

/** Stable card frame shared by every Journey Studio node renderer. Keep connection handles as children. */
export default function NodeCard({ type, selected, data, compact = false, children }) {
  const theme = nodeTheme[type] || nodeTheme.message;
  const stateClass = data?.isCurrent
    ? 'ring-4 ring-emerald-400/80 shadow-[0_0_24px_rgba(16,185,129,0.25)]'
    : data?.targetFlowMissing
      ? '!border-rose-500 ring-2 ring-rose-500/80 shadow-[0_0_24px_rgba(244,63,94,0.25)]'
      : selected
        ? theme.selectedRing
        : `hover:-translate-y-px hover:shadow-[0_14px_32px_-8px_rgba(15,23,42,0.15)] ${theme.borderGlow}`;

  return (
    <div
      data-node-card="true"
      data-node-type={type}
      className={[
        'journey-node-card group/card relative box-border cursor-grab border bg-white active:cursor-grabbing',
        compact ? 'w-[248px] min-w-[248px] rounded-2xl px-3 pt-3 pb-2.5' : 'w-[288px] min-w-[288px] rounded-[18px] px-4 pt-3.5 pb-3',
        'shadow-[0_8px_24px_-8px_rgba(15,23,42,0.12)] transition-[border-color,box-shadow,transform] duration-150 dark:bg-slate-900 dark:shadow-[0_12px_30px_rgba(0,0,0,0.38)]',
        theme.border,
        stateClass,
      ].join(' ')}
    >
      <div aria-hidden="true" className={`absolute inset-x-0 top-0 h-[3px] rounded-t-[18px] ${theme.accentBar}`} />
      {children}
    </div>
  );
}
